
import { defuFn } from '/var/intelvision/digibms-portal/node_modules/defu/dist/defu.mjs'

const inlineConfig = {}

import cfg0 from "/var/intelvision/digibms-portal/src/app.config.ts"

export default /* #__PURE__ */ defuFn(cfg0, inlineConfig)
